import React from "react";
import { Link } from "react-router-dom";
import { FaqResourcePage } from "../components/FaqResourcePage";
import { CALENDLY_URL, TRUST_FAQ_SECTIONS } from "../data/content";

const TrustServicesFaq = () => (
  <FaqResourcePage
    pageTestId="trust-services-faq-page"
    kicker="Trust Services Consulting FAQs"
    h1Lines={[
      <span key="a">Trust services consulting —</span>,
      <span key="b">
        your questions <em className="italic text-[#3E9BDC]">answered.</em>
      </span>,
    ]}
    intro={
      <>
        Trust-company decisions require more than a charter application or a policy manual. The right
        approach connects strategy, governance, fiduciary responsibilities, operations and regulatory
        readiness. These answers address common questions from existing trust companies and RIAs
        evaluating a trust-company opportunity. American Elm Advisors provides practical trust services
        consulting for firms seeking to evaluate, prepare, establish or strengthen a fiduciary business.
        Explore our{" "}
        <Link
          to="/trust-services-consulting"
          data-testid="faq-intro-service-link"
          className="text-[#3E9BDC] font-semibold hover:underline underline-offset-4"
        >
          Trust Services consulting page
        </Link>{" "}
        or{" "}
        <Link
          to="/who-we-are"
          data-testid="faq-intro-team-link"
          className="text-[#3E9BDC] font-semibold hover:underline underline-offset-4"
        >
          meet our team
        </Link>{" "}
        to learn more.
      </>
    }
    primaryCta={{ label: "Explore a trust strategy", to: "/contact?topic=Trust%20Services%20Consulting" }}
    sections={TRUST_FAQ_SECTIONS}
    inlineCta={{
      afterSectionId: "charter-readiness",
      body: "Every trust-company decision is different. Tell us about yours and we'll help you scope the right support.",
      buttonLabel: "Discuss your situation",
      to: "/contact?topic=Trust%20Services%20Consulting",
      eventName: "faq_inline_trust",
    }}
    closing={{
      heading: "Explore a trust strategy.",
      body: "A candid conversation about feasibility, readiness or operational priorities is the right place to start.",
      primary: { label: "Request a consultation", to: "/contact?topic=Trust%20Services%20Consulting" },
      secondary: { label: "Schedule a 15-minute call", to: CALENDLY_URL, external: true },
    }}
    related={[
      { label: "Compliance consulting", to: "/compliance-consulting" },
      { label: "AML independent audits", to: "/aml-independent-audits" },
      { label: "Capital markets consulting", to: "/capital-markets-consulting" },
    ]}
  />
);

export default TrustServicesFaq;
